import apollo from '@/graphql'
import gql from 'graphql-tag'

import deviceAssignmentHistoryQuery from '@/graphql/device/DeviceAssignmentHistory.gql'
import DeviceRemovalReasonsQuery from '@/graphql/device/DeviceRemovalReasonsQuery.gql'
import DeviceDetailsQuery from '@/graphql/device/DeviceDetailsQuery.gql'
import RunDeviceWifiScan from '@/graphql/device/RunDeviceWifiScan.gql'
import SaveDeviceDetails from '@/graphql/device/SaveDeviceDetails.gql'

// initial state
const state = {
  deviceDetails: {},
  editableDeviceFields: {},
  deviceAssignmentHistory: [],
  deviceRemovalReasons: [],
}

// getters
const getters = {
  deviceDetails: st => st.deviceDetails,
  editableDeviceFields: st => st.editableDeviceFields,
  deviceAssignmentHistory: st => st.deviceAssignmentHistory,
  deviceRemovalReasons: st => st.deviceRemovalReasons,
}

// mutations
const mutations = {
  setDeviceHistory(st, deviceHistory) {
    state.deviceAssignmentHistory = deviceHistory
  },

  setDeviceDetails(st, deviceDetails) {
    state.deviceDetails = deviceDetails
  },

  setDeviceRemovalReasons(st, removalReasons) {
    state.deviceRemovalReasons = removalReasons
  },

  setEditableDeviceFields(st, deviceDetails) {
    state.editableDeviceFields = {
      id: deviceDetails.id,
      isPortsEnabled: deviceDetails.isPortsEnabled,
      hardwareId: deviceDetails.hardware.id,
      isMediaPlayer: deviceDetails.isMediaPlayer,
    }
  },
}

// actions
const actions = {
  getConnectionLogs(context, { id }) {
    return apollo.defaultClient.mutate({
      mutation: gql`
        mutation getConnectionLogs($id: Int!) {
          getConnectionLogs(id: $id)
        }
      `,
      variables: { id: +id },
    }).then(({ data: { getConnectionLogs } }) => getConnectionLogs)
  },

  getDeviceAssignmentHistory({ commit }, { deviceId }) {
    apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: deviceAssignmentHistoryQuery,
        variables: { deviceId },
      })
      .then(({ data: { deviceAssignmentHistory } }) => {
        commit('setDeviceHistory', deviceAssignmentHistory)
      })
  },

  getDeviceStoreNotes({ commit }, { deviceId }) {
    apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: deviceAssignmentHistoryQuery,
        variables: { deviceId },
      })
      .then(({ data: { deviceAssignmentHistory } }) => {
        commit('setDeviceHistory', deviceAssignmentHistory)
      })
  },

  getDeviceRemovalReasons({ commit }) {
    apollo.defaultClient
      .query({
        query: DeviceRemovalReasonsQuery,
      })
      .then(({ data: { deviceRemovalReasons } }) => {
        commit('setDeviceRemovalReasons', deviceRemovalReasons)
      })
  },

  loadDeviceDetails({ commit }, { id }) {
    apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: DeviceDetailsQuery,
        variables: { id: +id },
      })
      .then(({ data: { deviceDetails } }) => {
        commit('setDeviceDetails', deviceDetails)
        commit('setEditableDeviceFields', deviceDetails)
      })
  },

  runDeviceWifiScan(context, { $message }) {
    const startTime = Date.now()
    const deviceId = state.editableDeviceFields.id
    apollo.defaultClient
      .mutate({
        mutation: RunDeviceWifiScan,
        variables: {
          id: state.editableDeviceFields.id,
        },
        refetchQueries: [{
          query: DeviceDetailsQuery,
          variables: {
            id: state.editableDeviceFields.id,
          },
        }],
      })
      .catch((err) => {
        $message({
          message: err,
          type: 'error',
        })
      })
    context.dispatch('loadDeviceDetails', {
      id: state.editableDeviceFields.id,
    })
    const myInterval = setInterval(() => {
      const isTimeCompleted = state.deviceDetails.lastWifiScan.timeCompleted
      const timeOut = Date.now() - startTime > 53e3
      context.dispatch('loadDeviceDetails', {
        id: state.editableDeviceFields.id,
      })
      if (deviceId !== state.editableDeviceFields.id || isTimeCompleted || timeOut) {
        clearInterval(myInterval)
      }
    }, 7000)
  },

  saveDeviceDetails(context, { $message }) {
    apollo.defaultClient
      .mutate({
        mutation: SaveDeviceDetails,
        variables: {
          fields: state.editableDeviceFields,
        },
        refetchQueries: [state.deviceDetails.id].filter(id => id).map(id => ({
          query: DeviceDetailsQuery,
          variables: { id: +id },
        })),
      })
      .then(({ data: { saveDeviceDetails: { id } } }) => {
        $message({
          message: `Device details saved for Device ${id}`,
          type: 'success',
        })
      })
      .catch((err) => {
        $message({
          message: err,
          type: 'error',
        })
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/device/DeviceDetails.js